import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordInputComponent } from './password-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [PasswordInputComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AngularSvgIconModule],
  exports: [PasswordInputComponent],
})
export class PasswordInputModule {}
